














import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import { GuardrailStatus } from "@/models";

@Component
export default class InfusionGuardrailStatus extends Vue {
  @Prop() readonly status!: GuardrailStatus;

  get show(): boolean {
    const status = this.status ?? GuardrailStatus.Normal;
    return status !== GuardrailStatus.Normal;
  }

  get isAbove(): boolean {
    return this.status === GuardrailStatus.Above;
  }
}
